const localePrefix = /^\/(en|sr)(?=\/|$)/;

/**
 * Rewrites the first path segment to match the active app locale (`en` | `sr`).
 * Used for hrefs that were frozen at module load (nav data, defineOptions) or
 * when Wayfinder defaults lag behind Inertia props during client visits.
 */
export function localizeHref(href: unknown, locale: unknown): string {
    if (typeof href !== 'string' || href === '') {
        return typeof href === 'string' ? href : '';
    }

    const loc = locale === 'sr' ? 'sr' : 'en';

    if (href.startsWith('/')) {
        return href.replace(localePrefix, `/${loc}`);
    }

    try {
        const base =
            typeof window !== 'undefined'
                ? window.location.origin
                : 'http://localhost';
        const url = new URL(href, base);
        url.pathname = url.pathname.replace(localePrefix, `/${loc}`);

        return href.startsWith('http')
            ? url.toString()
            : url.pathname + url.search + url.hash;
    } catch {
        return href;
    }
}
